import styled from '@emotion/styled';

import type { Author as AuthorType } from './Message.types';

type Props = {
  author: AuthorType;
};

export const Wrapper = styled.div<Props>`
  display: flex;
  justify-content: ${(props) => (props.author === 'amelia' ? 'start' : 'end')};
`;

export const Author = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
  font: var(--font-label-xl-bold);
  color: var(--color-secondary-40);
`;

export const Avatar = styled.img`
  width: 24px;
  height: 28px;
`;

export const Bubble = styled.div<Props>`
  width: auto;
  max-width: 30rem;
  margin-top: var(--spacing-8);
  padding: var(--spacing-16);
  border-radius: var(--border-radius-l);
  font: var(--font-body-l-light);
  overflow-wrap: anywhere;
  background: ${(props) =>
    props.author === 'amelia'
      ? 'var(--color-white)'
      : 'var(--color-secondary-50)'};
  color: ${(props) =>
    props.author === 'amelia'
      ? 'var(--color-secondary-40)'
      : 'var(--color-secondary-97)'};

  p {
    color: inherit;

    & + p {
      margin-top: var(--spacing-16);
    }
  }
`;

export const Explainer = styled.div`
  margin-top: var(--spacing-24);
  font: var(--font-body-m-light);
  color: var(--color-secondary-70);
`;

export const ButtonWrapper = styled.div`
  margin-top: var(--spacing-24);
`;
